import styled, { css, DefaultTheme } from "styled-components";
import { FontWeightEnum } from "../../types/AppTypes";

type SyledFontWeightProps = {
  $fontWeight?: FontWeightEnum;
};

/* variants */

const variantStyles = (
  theme: DefaultTheme,
  fontWeight = FontWeightEnum.REGULAR,
) =>
  ({
    semiBold: css`
      & > span {
        font-weight: ${theme.variables.fw_semiBold};
      }
    `,
    medium: css`
      & > span {
        font-weight: ${theme.variables.fw_medium};
      }
    `,
    regular: css`
      & > span {
        font-weight: ${theme.variables.fw_Regular};
      }
    `,
  })[fontWeight];

const SyledFontWeight = styled.span<SyledFontWeightProps>`
  ${({ theme, $fontWeight: fontWeight }) => variantStyles(theme, fontWeight)}
`;

export { SyledFontWeight };
